// extracted by mini-css-extract-plugin
export default {"container":"HistoryClientDetailTab_container__+6FWl","noData":"HistoryClientDetailTab_noData__2ToRG","viewHeader":"HistoryClientDetailTab_viewHeader__uybfA"};